<template>
    <div class="invoice">
    <div class="d-flex justify-content-between">
        <h1>Confirmation of Scheduled Payment</h1>
        <h5 class='text-muted'>Payment #{{ invoice.invoiceRefNumber }}</h5>
    </div>
      <div class="invoice-header">
        <br>
        <div class="row">
            <div class="col-4">
                <h6>{{ invoice.type != 'subscription' ? 'ADDITIONAL' : ''}} PROFILES PURCHASED</h6>
                <span> {{ invoice.profiles }}</span>
            </div>
            <div class="col-4">
                <h6>{{isFutureInvoice ? "AMOUNT TO BE PAID" : "AMOUNT PAID"}}</h6>
                <span>{{ invoice.currency }} {{ invoice.totalAmount }}</span>
            </div>
            <div class="col-4">
                <h6>{{isFutureInvoice ? "DUE DATE" : "DATE PAID"}} </h6>
                <!-- <span>{{invoice.date | moment(isFutureInvoice ? 'MMMM D, YYYY' : 'MMMM D, YYYY, h:mm A')}}</span> -->
                <span>{{invoice.date | moment('MMMM D, YYYY')}}</span>
            </div>
        </div>
      </div>
      
      <div class="invoice-items">
        <h5>Summary</h5>
        <br>
        <b-table :fields="invoiceFields" :items="invoice.items">
        </b-table>
      </div>
      <template v-if="invoice.taxDetails && invoice.taxDetails.length">
        <div class="row mt-3">
            <div class="col-6"></div>
            <div class="col-3 text-muted" style="font-size: 16px; ">Sub Total</div>
            <div class="col-3 font-weight-bold" style="font-size: 16px;">{{ invoice.currency }} {{ invoice.subTotalAmount }}</div>
        </div>
        <div v-for="tax in invoice.taxDetails" class="row mt-3">
            <div class="col-6"></div>
            <div class="col-3 text-muted" style="font-size: 16px; ">{{ tax.title }} ({{ tax.percentage }}%)</div>
            <div class="col-3 font-weight-bold" style="font-size: 16px;">{{ invoice.currency }} {{ tax.amount }}</div>
        </div>

      </template>
      <div class="row mt-3">
        <div class="col-6"></div>
        <div class="col-3 text-muted" style="font-size: 16px; ">Total Amount</div>
        <div class="col-3 font-weight-bold" style="font-size: 16px;">{{ invoice.currency }} {{ invoice.totalAmount }}</div>
    </div>

    </div>
  </template>
  
  <script>
  export default {
    props: {
      invoice: {
        type: Object,
        required: true
      }
    },
    data(){
        return {
        }
    },
    computed: {
        isFutureInvoice(){
            return (new Date(this.invoice.date)) > (new Date())
        },
        invoiceFields(){
            return[
                {
                    title: {
                        label: 'Description',
                        tdAttr: {
                            dataname: 'title',
                        },
                    },
                },
                ...(this.invoice.type == 'subscription' ? [] : [
                    {
                        quantity: {
                            label: 'Quantity',
                            tdAttr: {
                                dataname: 'quantity',
                            },
                        },
                    },
                    {
                        price: {
                            label: 'Price',
                            tdAttr: {
                                dataname: 'price',
                            },
                        },
                    },

                ]),
                {
                    total: {
                        label: 'Total',
                        tdAttr: {
                            dataname: 'total',
                        },
                    },
                },
            ]
        }
    }
  }
  </script>
  
  <style scoped>
  .invoice {
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    /* max-width: 600px;
    margin: 0 auto; */
  }
  
  .invoice-header, .invoice-items, .invoice-tax, .invoice-totals {
    margin-bottom: 20px;
  }
  
  .invoice-items ul, .invoice-tax ul {
    list-style-type: none;
    padding: 0;
  }
  
  .invoice-items li, .invoice-tax li {
    margin-bottom: 10px;
  }
  </style>
  